(function () {
  'use strict';

  /* ============================================================
     RSI WE BUY RACKING — Page-scoped JS
     1. Before/after switcher
     2. Mobile mini-card accordion group (one open at a time)
     3. Desktop: force "How it works" / mini-card <details> open

     Media upload previews/compression and form submission (webhook or
     Shopify contact fallback) used to live here too — both moved to
     assets/rsi-lead-form-upload.js, shared with the installation page's
     enquiry form, so both get the same fix/behaviour from one place.
  ============================================================ */

  // ---- 3. Desktop: force "How it works" steps + mini-card details open ----
  // assets/rsi-we-buy-racking.css has a desktop rule making
  // ".rsi-wb-collapse__body" always "display:block" so this content reads
  // as plain always-visible text on desktop, with the accordion only
  // becoming a real click-to-expand interaction below 990px. That CSS-only
  // override no longer works in current Chromium: a closed native
  // "<details>" now hides its content through an internal mechanism the
  // browser doesn't let a "display" override on the inner element defeat -
  // only the element's real "open" state does. Confirmed live: the "How it
  // works" numbered steps and each mini-card's description + "Get a quote"
  // link were rendering with zero visible content on desktop (present in
  // the layout, invisible) - exactly the reported "excessive empty white
  // space". Scoped to ".rsi-wb-process-services .rsi-wb-collapse" plus any
  // element explicitly opted in via "[data-rsi-force-open-desktop]" (the
  // enquiry form's own "More details (optional)" <details> hit this same
  // bug — confirmed there too, fields rendering at 0 visual height on
  // desktop). One-directional - it only ever opens on desktop, never
  // force-closes on mobile, so a user's own accordion taps are never
  // overridden.
  (function () {
    var items = document.querySelectorAll(
      '.rsi-wb-process-services .rsi-wb-collapse, [data-rsi-force-open-desktop]'
    );
    if (!items.length) return;
    var desktopQuery = window.matchMedia('(min-width: 990px)');

    function openForDesktop() {
      if (!desktopQuery.matches) return;
      items.forEach(function (item) {
        item.open = true;
      });
    }

    openForDesktop();
    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', openForDesktop);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(openForDesktop);
    }
  })();

  // ---- 2. Mobile mini-card accordion group ----
  // Guarded to mobile widths only (was already mobile-only in intent per
  // the heading above, just not enforced in code) - without this check,
  // section 3's desktop force-open loop above would trigger this same
  // "toggle" listener on every card and have it close all the others
  // straight back down again, since setting ".open" fires a real native
  // toggle event indistinguishable from a user click.
  document.querySelectorAll('[data-rsi-wb-accordion-group]').forEach(function (group) {
    var items = group.querySelectorAll('details.rsi-wb-collapse');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        if (window.matchMedia('(min-width: 990px)').matches) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  // ---- 1. Before/after switcher ----
  document.querySelectorAll('[data-rsi-we-buy-switcher]').forEach(function (wrap) {
    var tabs   = wrap.querySelectorAll('[data-rsi-we-buy-view]');
    var panels = wrap.querySelectorAll('[data-rsi-we-buy-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-rsi-we-buy-view');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          if (p.getAttribute('data-rsi-we-buy-panel') === target) {
            p.classList.add('is-active');
          } else {
            p.classList.remove('is-active');
          }
        });
      });
    });
  });

})();
